import React, { createContext, useContext, useState, useEffect } from "react";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const numberFormatLocal = localStorage.getItem("userLocale");
  const storedPermissions = localStorage.getItem("rolePermissionList");
  const storedUserType = localStorage.getItem("userType");

  const [rolePermissionList, setRolePermissionList] = useState(
    storedPermissions ? JSON.parse(storedPermissions) : []
  );
  const [userType, setUserType] = useState(storedUserType ?? "");
  const [numberType, setNumberType] = useState(numberFormatLocal ?? "");
  const [orgImage, setOrgImage] = useState("");
  const [headerDetails, setHeaderDetails] = useState({});
  useEffect(() => {
    localStorage.setItem("rolePermissionList", JSON.stringify(rolePermissionList));
    localStorage.setItem("userType", userType);
    localStorage.setItem("userLocale", numberType);
  }, [rolePermissionList, userType, numberType]);

  return (
    <GlobalContext.Provider
      value={{
        rolePermissionList,
        setRolePermissionList,
        userType,
        setUserType,
        numberType,
        setNumberType,
        isCollapsed, headerDetails, setHeaderDetails,
        setIsCollapsed, orgImage, setOrgImage,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobal() must be used within a GlobalProvider");
  }
  return context;
};
